import { render, staticRenderFns } from "./OrderRatingFormWidget.vue?vue&type=template&id=57cd2048&scoped=true&"
import script from "./OrderRatingFormWidget.vue?vue&type=script&lang=ts&"
export * from "./OrderRatingFormWidget.vue?vue&type=script&lang=ts&"
import style0 from "./OrderRatingFormWidget.vue?vue&type=style&index=0&id=57cd2048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cd2048",
  null
  
)

export default component.exports